import { useEffect, useState } from 'react';
/**
 * Tracks the size of `ref.current` with `ResizeObserver`. Does nothing during
 * SSR, when disabled, or where `ResizeObserver` is unavailable.
 */
export const useResizeObserver = ({ ref, onResize, box = 'content-box', enabled = true, }) => {
    const [size, setSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        const element = ref.current;
        if (!enabled || !element || typeof ResizeObserver === 'undefined')
            return;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (!entry) {
                return;
            }
            let width;
            let height;
            if (box === 'border-box' && entry.borderBoxSize?.[0]) {
                width = entry.borderBoxSize?.[0]?.inlineSize;
                height = entry.borderBoxSize?.[0]?.blockSize;
            }
            else if (box === 'device-pixel-content-box' && entry.devicePixelContentBoxSize?.[0]) {
                width = entry.devicePixelContentBoxSize?.[0]?.inlineSize;
                height = entry.devicePixelContentBoxSize?.[0]?.blockSize;
            }
            else if (box === 'content-box' && entry.contentBoxSize?.[0]) {
                width = entry.contentBoxSize?.[0]?.inlineSize;
                height = entry.contentBoxSize?.[0]?.blockSize;
            }
            else {
                width = entry.contentRect.width;
                height = entry.contentRect.height;
            }
            const newSize = { width, height };
            if (onResize)
                onResize(newSize);
            else
                setSize(newSize);
        });
        observer.observe(element, { box });
        return () => {
            observer.disconnect();
        };
    }, [ref, box, onResize, enabled]);
    return size;
};
//# sourceMappingURL=useResizeObserver.js.map